import { inject, Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { ToastService } from "@shared/services/toast/toast.service";
import { AppConfigService } from "@api/services/app-config.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private readonly toastService = inject(ToastService);
    private readonly appConfigService = inject(AppConfigService);
    private readonly appConfig = this.appConfigService.appConfig;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (
                    error.url &&
                    !/\/searches\/[^/]+\/result\/total-record-count/.test(error.url) &&
                    !/\/searches\/[^/]+\/result/.test(error.url)
                ) {
                    this.handleError(error);
                }

                return throwError(() => error);
            }),
        );
    }

    private handleError(error: HttpErrorResponse): void {
        let errorMessage = "";
        let errorTitle = `Error Code: ${error.status}`;

        if (error.error instanceof ErrorEvent) {
            errorTitle = "Error";
            errorMessage = `Message: ${error.error.message}`;
        } else if (this.appConfig && error.url!.includes(this.appConfig().identityServer)) {
            errorMessage = `Message: ${error.error?.error ?? error.error.split("\n")[0]}`;
        } else if (error.status === 403) {
            errorTitle = "Access Denied";
            errorMessage =
                "Message: You do not have permission to access this resource. Please contact your administrator if you believe this is an error.";
        } else {
            errorMessage = `Message: ${error.error?.detail ?? error.error.title}`;
        }

        this.toastService.showErrorToast(errorTitle, errorMessage);
    }
}
